import { Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const TooltipWrapper = ({ hideFeedback, children }) => {
	const { t } = useTranslation(['candidate-feedback']);
	return hideFeedback ? (
		<Tooltip title={t('visible_once_you_have_submitted_your_feedback')} placement="top">
			<div>{children}</div>
		</Tooltip>
	) : (
		children
	);
};

export default TooltipWrapper;
